/**
 * 服务费相关
 */
import Net from '../net';

const NAME = '[ServiceChargeApi]';
const Log = (...p) => { console['log'](NAME, ...p); }


/** === ServiceCharge === **/
/** export-task/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.type
*/
export async function exportServiceChargeList(data = {}) {
  Log('exportServiceChargeList data:', data)
  try {
    const res = await Net.http('export-task/list', { data })
    Log('exportServiceChargeList res:', res)
    return res
  } catch (err) {
    Log('exportServiceChargeList err:', err)
    throw err
  }
}


/** === ServiceChargeStat === **/
/** device-account-money/service-fee-summary-detail
 * @param {Object} data
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.device_uid
*/
export async function serviceChargeStatSummary(data = {}) {
  Log('serviceChargeStatSummary data:', data)
  try {
    const res = await Net.http('device-account-money/service-fee-summary-detail', { data })
    Log('serviceChargeStatSummary res:', res)
    return res
  } catch (err) {
    Log('serviceChargeStatSummary err:', err)
    throw err
  }
}

/** service-fee-order/service-fee-detail
 * @param {Object} data
 * @param {*} data.operator_id
*/
export async function serviceChargeStatSummaryOld(data = {}) {
  Log('serviceChargeStatSummaryOld data:', data)
  try {
    const res = await Net.http('service-fee-order/service-fee-detail', { data })
    Log('serviceChargeStatSummaryOld res:', res)
    return res
  } catch (err) {
    Log('serviceChargeStatSummaryOld err:', err)
    throw err
  }
}

/** device-account-money/service-fee-operator-summary-detail-list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.order
 * @param {*} data.operator_id
*/
export async function serviceChargeStatOperatorList(data = {}) {
  Log('serviceChargeStatOperatorList data:', data)
  try {
    const res = await Net.http('device-account-money/service-fee-operator-summary-detail-list', { data })
    Log('serviceChargeStatOperatorList res:', res)
    return res
  } catch (err) {
    Log('serviceChargeStatOperatorList err:', err)
    throw err
  }
}

/** device-account-money/service-fee-org-summary-detail-list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.order
 * @param {*} data.operator_id
 * @param {*} data.org_id
*/
export async function serviceChargeStatOrgList(data = {}) {
  Log('serviceChargeStatOrgList data:', data)
  try {
    const res = await Net.http('device-account-money/service-fee-org-summary-detail-list', { data })
    Log('serviceChargeStatOrgList res:', res)
    return res
  } catch (err) {
    Log('serviceChargeStatOrgList err:', err)
    throw err
  }
}

/** device-account-money/service-fee-device-summary-detail-list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.order
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.device_uid
*/
export async function serviceChargeStatDeviceList(data = {}) {
  Log('serviceChargeStatDeviceList data:', data)
  try {
    const res = await Net.http('device-account-money/service-fee-device-summary-detail-list', { data })
    Log('serviceChargeStatDeviceList res:', res)
    return res
  } catch (err) {
    Log('serviceChargeStatDeviceList err:', err)
    throw err
  }
}

/** device-account-money/station-device-account-detail-list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.station_id
 * @param {*} data.device_uid
 * @param {*} data.search_device_uid
*/
export async function serviceChargeStatDeviceByStation(data = {}) {
  Log('serviceChargeStatDeviceByStation data:', data)
  try {
    const res = await Net.http('device-account-money/station-device-account-detail-list', { data })
    Log('serviceChargeStatDeviceByStation res:', res)
    return res
  } catch (err) {
    Log('serviceChargeStatDeviceByStation err:', err)
    throw err
  }
}


/** === ServiceChargeBill === **/
/** service-fee-order/stat-service-fee-order
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.operator_id
 * @param {*} data.time
*/
export async function serviceChargeBillBillList(data = {}) {
  Log('serviceChargeBillBillList data:', data)
  try {
    const res = await Net.http('service-fee-order/stat-service-fee-order', { data })
    Log('serviceChargeBillBillList res:', res)
    return res
  } catch (err) {
    Log('serviceChargeBillBillList err:', err)
    throw err
  }
}

/** device-account-money/service-fee-operator-bill-list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.time
 * @param {*} data.operator_id
*/
export async function serviceChargeBillOperatorList(data = {}) {
  Log('serviceChargeBillOperatorList data:', data)
  try {
    const res = await Net.http('device-account-money/service-fee-operator-bill-list', { data })
    Log('serviceChargeBillOperatorList res:', res)
    return res
  } catch (err) {
    Log('serviceChargeBillOperatorList err:', err)
    throw err
  }
}

/** device-account-money/service-fee-org-bill-list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.time
 * @param {*} data.operator_id
 * @param {*} data.org_id
*/
export async function serviceChargeBillOrgList(data = {}) {
  Log('serviceChargeBillOrgList data:', data)
  try {
    const res = await Net.http('device-account-money/service-fee-org-bill-list', { data })
    Log('serviceChargeBillOrgList res:', res)
    return res
  } catch (err) {
    Log('serviceChargeBillOrgList err:', err)
    throw err
  }
}

/** device-account-money/service-fee-device-bill-list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.time
 * @param {*} data.operator_id
 * @param {*} data.org_id
 * @param {*} data.device_uid
*/
export async function serviceChargeBillDeviceList(data = {}) {
  Log('serviceChargeBillDeviceList data:', data)
  try {
    const res = await Net.http('device-account-money/service-fee-device-bill-list', { data })
    Log('serviceChargeBillDeviceList res:', res)
    return res
  } catch (err) {
    Log('serviceChargeBillDeviceList err:', err)
    throw err
  }
}


/** === ServiceChargeTemp === **/
/** service-fee-package/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.name
 * @param {*} data.payment_mode
*/
export async function getServiceChargeTempList(data = {}) {
  Log('getServiceChargeTempList data:', data)
  try {
    const res = await Net.http('service-fee-package/list', { data })
    Log('getServiceChargeTempList res:', res)
    return res
  } catch (err) {
    Log('getServiceChargeTempList err:', err)
    throw err
  }
}

/** service-fee-package/save
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.name
 * @param {*} data.payment_mode
 * @param {*} data.config
*/
export async function saveServiceChargeTemp(data = {}) {
  Log('saveServiceChargeTemp data:', data)
  try {
    const res = await Net.http('service-fee-package/save', { data })
    Log('saveServiceChargeTemp res:', res)
    return res
  } catch (err) {
    Log('saveServiceChargeTemp err:', err)
    throw err
  }
}

/** service-fee-package/detail
 * @param {Object} data
 * @param {*} data.id
*/
export async function getServiceChargeTempDetail(data = {}) {
  Log('getServiceChargeTempDetail data:', data)
  try {
    const res = await Net.http('service-fee-package/detail', { data })
    Log('getServiceChargeTempDetail res:', res)
    return res
  } catch (err) {
    Log('getServiceChargeTempDetail err:', err)
    throw err
  }
}

/** service-fee-package/delete
 * @param {Object} data
 * @param {*} data.id
*/
export async function deleteServiceChargeTemp(data = {}) {
  Log('deleteServiceChargeTemp data:', data)
  try {
    const res = await Net.http('service-fee-package/delete', { data })
    Log('deleteServiceChargeTemp res:', res)
    return res
  } catch (err) {
    Log('deleteServiceChargeTemp err:', err)
    throw err
  }
}


/** === ServiceChargeGroup === **/
/** service-fee-device-group/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.name
 * @param {*} data.package_id
 * @param {*} data.operator_id
 * @param {*} data.flag_charge
 * @param {*} data.flag_service_rate
 * @param {*} data.sort
*/
export async function getServiceChargeGroupList(data = {}) {
  Log('getServiceChargeGroupList data:', data)
  try {
    const res = await Net.http('service-fee-device-group/list', { data })
    Log('getServiceChargeGroupList res:', res)
    return res
  } catch (err) {
    Log('getServiceChargeGroupList err:', err)
    throw err
  }
}

/** service-fee-device-group/save
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.name
 * @param {*} data.package_id
 * @param {*} data.operator_id
*/
export async function saveServiceChargeGroup(data = {}) {
  Log('saveServiceChargeGroup data:', data)
  try {
    const res = await Net.http('service-fee-device-group/save', { data })
    Log('saveServiceChargeGroup res:', res)
    return res
  } catch (err) {
    Log('saveServiceChargeGroup err:', err)
    throw err
  }
}

/** service-fee-device-group/set-remark
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.remark
*/
export async function serviceChargeGroupRemark(data = {}) {
  Log('serviceChargeGroupRemark data:', data)
  try {
    const res = await Net.http('service-fee-device-group/set-remark', { data })
    Log('serviceChargeGroupRemark res:', res)
    return res
  } catch (err) {
    Log('serviceChargeGroupRemark err:', err)
    throw err
  }
}

/** service-fee-device-group/detail
 * @param {Object} data
 * @param {*} data.id
*/
export async function getServiceChargeGroupDetail(data = {}) {
  Log('getServiceChargeGroupDetail data:', data)
  try {
    const res = await Net.http('service-fee-device-group/detail', { data })
    Log('getServiceChargeGroupDetail res:', res)
    return res
  } catch (err) {
    Log('getServiceChargeGroupDetail err:', err)
    throw err
  }
}

/** service-fee-device-group/detail-by-operator
 * @param {Object} data
*/
export async function getServiceChargeGroupDetailByOperator(data = {}) {
  Log('getServiceChargeGroupDetailByOperator data:', data)
  try {
    const res = await Net.http('service-fee-device-group/detail-by-operator', { data })
    Log('getServiceChargeGroupDetailByOperator res:', res)
    return res
  } catch (err) {
    Log('getServiceChargeGroupDetailByOperator err:', err)
    throw err
  }
}

/** service-fee-device-group/delete
 * @param {Object} data
 * @param {*} data.id
*/
export async function deleteServiceChargeGroup(data = {}) {
  Log('deleteServiceChargeGroup data:', data)
  try {
    const res = await Net.http('service-fee-device-group/delete', { data })
    Log('deleteServiceChargeGroup res:', res)
    return res
  } catch (err) {
    Log('deleteServiceChargeGroup err:', err)
    throw err
  }
}

/** service-fee-device-group/set-flag-charge
 * @param {Object} data
 * @param {*} data.id
 * @param {*} data.ids
*/
export async function updateServiceChargeGroupStatus(data = {}) {
  Log('updateServiceChargeGroupStatus data:', data)
  try {
    const res = await Net.http('service-fee-device-group/set-flag-charge', { data })
    Log('updateServiceChargeGroupStatus res:', res)
    return res
  } catch (err) {
    Log('updateServiceChargeGroupStatus err:', err)
    throw err
  }
}


/** === ServiceChargeGroupItem === **/
/** device/get-device-for-service-fee
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.page_size
 * @param {*} data.uid
 * @param {*} data.operator_id
*/
export async function serviceChargeGroupItemOption(data = {}) {
  Log('serviceChargeGroupItemOption data:', data)
  try {
    const res = await Net.http('device/get-device-for-service-fee', { data })
    Log('serviceChargeGroupItemOption res:', res)
    return res
  } catch (err) {
    Log('serviceChargeGroupItemOption err:', err)
    throw err
  }
}

/** service-fee-device-group-item/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.group_id
 * @param {*} data.device_uid
 * @param {*} data.sort
*/
export async function getServiceChargeGroupItemList(data = {}) {
  Log('getServiceChargeGroupItemList data:', data)
  try {
    const res = await Net.http('service-fee-device-group-item/list', { data })
    Log('getServiceChargeGroupItemList res:', res)
    return res
  } catch (err) {
    Log('getServiceChargeGroupItemList err:', err)
    throw err
  }
}

/** service-fee-device-group-item/save-device
 * @param {Object} data
 * @param {*} data.group_id
 * @param {*} data.uids
*/
export async function addServiceChargeGroupItem(data = {}) {
  Log('addServiceChargeGroupItem data:', data)
  try {
    const res = await Net.http('service-fee-device-group-item/save-device', { data })
    Log('addServiceChargeGroupItem res:', res)
    return res
  } catch (err) {
    Log('addServiceChargeGroupItem err:', err)
    throw err
  }
}

/** service-fee-device-group-item/sync-operator-device
 * @param {Object} data
 * @param {*} data.operator_id
*/
export async function serviceChargeGroupItemSync(data = {}) {
  Log('serviceChargeGroupItemSync data:', data)
  try {
    const res = await Net.http('service-fee-device-group-item/sync-operator-device', { data })
    Log('serviceChargeGroupItemSync res:', res)
    return res
  } catch (err) {
    Log('serviceChargeGroupItemSync err:', err)
    throw err
  }
}

/** service-fee-device-group-item/import-group-device
 * @param {Object} data
 * @param {*} data.group_id
 * @param {*} data.operator_id
 * @param {*} data.file
*/
export async function serviceChargeGroupItemImport(data = {}) {
  Log('serviceChargeGroupItemImport data:', data)
  try {
    const res = await Net.http('service-fee-device-group-item/import-group-device', { data })
    Log('serviceChargeGroupItemImport res:', res)
    return res
  } catch (err) {
    Log('serviceChargeGroupItemImport err:', err)
    throw err
  }
}

/** service-fee-device-group-item/delete-device
 * @param {Object} data
 * @param {*} data.ids
*/
export async function serviceChargeGroupItemRemove(data = {}) {
  Log('serviceChargeGroupItemRemove data:', data)
  try {
    const res = await Net.http('service-fee-device-group-item/delete-device', { data })
    Log('serviceChargeGroupItemRemove res:', res)
    return res
  } catch (err) {
    Log('serviceChargeGroupItemRemove err:', err)
    throw err
  }
}

/** service-fee-device-group-item/add-gateway-list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.group_id
*/
export async function serviceChargeGroupItemGatewayList(data = {}) {
  Log('serviceChargeGroupItemGatewayList data:', data)
  try {
    const res = await Net.http('service-fee-device-group-item/add-gateway-list', { data })
    Log('serviceChargeGroupItemGatewayList res:', res)
    return res
  } catch (err) {
    Log('serviceChargeGroupItemGatewayList err:', err)
    throw err
  }
}

/** service-fee-device-group-item/add-device-list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.page_size
 * @param {*} data.group_id
 * @param {*} data.uid
*/
export async function serviceChargeGroupItemDeviceList(data = {}) {
  Log('serviceChargeGroupItemDeviceList data:', data)
  try {
    const res = await Net.http('service-fee-device-group-item/add-device-list', { data })
    Log('serviceChargeGroupItemDeviceList res:', res)
    return res
  } catch (err) {
    Log('serviceChargeGroupItemDeviceList err:', err)
    throw err
  }
}

/** service-fee-device-group-item/detail
 * @param {Object} data
 * @param {*} data.operator_id
 * @param {*} data.device_uid
*/
export async function getServiceChargeGroupItemDetail(data = {}) {
  Log('getServiceChargeGroupItemDetail data:', data)
  try {
    const res = await Net.http('service-fee-device-group-item/detail', { data })
    Log('getServiceChargeGroupItemDetail res:', res)
    return res
  } catch (err) {
    Log('getServiceChargeGroupItemDetail err:', err)
    throw err
  }
}

/** account/device-service-fee-transfer
 * @param {Object} data
 * @param {*} data.from_device_uid
 * @param {*} data.to_device_uid
 * @param {*} data.operator_id
*/
export async function serviceChargeGroupItemTransfer(data = {}) {
  Log('serviceChargeGroupItemTransfer data:', data)
  try {
    const res = await Net.http('account/device-service-fee-transfer', { data })
    Log('serviceChargeGroupItemTransfer res:', res)
    return res
  } catch (err) {
    Log('serviceChargeGroupItemTransfer err:', err)
    throw err
  }
}

/** device-account-money/device-account-detail-list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.device_uid
 * @param {*} data.subject
 * @param {*} data.begin_time
 * @param {*} data.end_time
*/
export async function serviceChargeGroupItemMoneyList(data = {}) {
  Log('serviceChargeGroupItemMoneyList data:', data)
  try {
    const res = await Net.http('device-account-money/device-account-detail-list', { data })
    Log('serviceChargeGroupItemMoneyList res:', res)
    return res
  } catch (err) {
    Log('serviceChargeGroupItemMoneyList err:', err)
    throw err
  }
}


/** === ServiceChargeOrder === **/
/** service-fee-order/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.operator_id
 * @param {*} data.device_uid
 * @param {*} data.begin_time
 * @param {*} data.end_time
 * @param {*} data.version
*/
export async function serviceChargeOrderOrderList(data = {}) {
  Log('serviceChargeOrderOrderList data:', data)
  try {
    const res = await Net.http('service-fee-order/list', { data })
    Log('serviceChargeOrderOrderList res:', res)
    return res
  } catch (err) {
    Log('serviceChargeOrderOrderList err:', err)
    throw err
  }
}

/** device-account/service-fee-charge-order-list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.operator_id
 * @param {*} data.order_sn
 * @param {*} data.begin_time
 * @param {*} data.end_time
 * @param {*} data.status
*/
export async function serviceChargeOrderRechargeList(data = {}) {
  Log('serviceChargeOrderRechargeList data:', data)
  try {
    const res = await Net.http('device-account/service-fee-charge-order-list', { data })
    Log('serviceChargeOrderRechargeList res:', res)
    return res
  } catch (err) {
    Log('serviceChargeOrderRechargeList err:', err)
    throw err
  }
}

/** device-account-money/recharge-detail
 * @param {Object} data
 * @param {*} data.charge_order_id
*/
export async function serviceChargeOrderRechargeDetails(data = {}) {
  Log('serviceChargeOrderRechargeDetails data:', data)
  try {
    const res = await Net.http('device-account-money/recharge-detail', { data })
    Log('serviceChargeOrderRechargeDetails res:', res)
    return res
  } catch (err) {
    Log('serviceChargeOrderRechargeDetails err:', err)
    throw err
  }
}

/** device-account-money/recharge-detail-list
 * @param {Object} data
 * @param {*} data.charge_order_id
 * @param {*} data.page
*/
export async function serviceChargeOrderRechargeDetailList(data = {}) {
  Log('serviceChargeOrderRechargeDetailList data:', data)
  try {
    const res = await Net.http('device-account-money/recharge-detail-list', { data })
    Log('serviceChargeOrderRechargeDetailList res:', res)
    return res
  } catch (err) {
    Log('serviceChargeOrderRechargeDetailList err:', err)
    throw err
  }
}

/** charge-order/confirm-pending-order
 * @param {Object} data
 * @param {*} data.charge_order_id
*/
export async function serviceChargeOrderConfirmPendingOrder(data = {}) {
  Log('serviceChargeOrderConfirmPendingOrder data:', data)
  try {
    const res = await Net.http('charge-order/confirm-pending-order', { data })
    Log('serviceChargeOrderConfirmPendingOrder res:', res)
    return res
  } catch (err) {
    Log('serviceChargeOrderConfirmPendingOrder err:', err)
    throw err
  }
}

/** charge-order/refund-pending-order
 * @param {Object} data
 * @param {*} data.charge_order_id
*/
export async function serviceChargeOrderRefundPendingOrder(data = {}) {
  Log('serviceChargeOrderRefundPendingOrder data:', data)
  try {
    const res = await Net.http('charge-order/refund-pending-order', { data })
    Log('serviceChargeOrderRefundPendingOrder res:', res)
    return res
  } catch (err) {
    Log('serviceChargeOrderRefundPendingOrder err:', err)
    throw err
  }
}

/** charge-order/action-list
 * @param {Object} data
 * @param {*} data.charge_order_id
 * @param {*} data.page
*/
export async function serviceChargeOrderAuditLogList(data = {}) {
  Log('serviceChargeOrderAuditLogList data:', data)
  try {
    const res = await Net.http('charge-order/action-list', { data })
    Log('serviceChargeOrderAuditLogList res:', res)
    return res
  } catch (err) {
    Log('serviceChargeOrderAuditLogList err:', err)
    throw err
  }
}


/** === ServiceChargeAccount === **/
/** account/service-fee-list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.sort
 * @param {*} data.operator_id
 * @param {*} data.group_name
 * @param {*} data.flag_service_rate
 * @param {*} data.version
*/
export async function getServiceChargeAccountList(data = {}) {
  Log('getServiceChargeAccountList data:', data)
  try {
    const res = await Net.http('account/service-fee-list', { data })
    Log('getServiceChargeAccountList res:', res)
    return res
  } catch (err) {
    Log('getServiceChargeAccountList err:', err)
    throw err
  }
}

/** account/service-fee-account-detail
 * @param {Object} data
 * @param {*} data.user_id
 * @param {*} data.version
*/
export async function serviceChargeAccountDeatil(data = {}) {
  Log('serviceChargeAccountDeatil data:', data)
  try {
    const res = await Net.http('account/service-fee-account-detail', { data })
    Log('serviceChargeAccountDeatil res:', res)
    return res
  } catch (err) {
    Log('serviceChargeAccountDeatil err:', err)
    throw err
  }
}

/** account-money/account-service-fee-list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.operator_id
 * @param {*} data.type
 * @param {*} data.begin_time
 * @param {*} data.end_time
 * @param {*} data.version
*/
export async function getServiceChargeAccountDetailList(data = {}) {
  Log('getServiceChargeAccountDetailList data:', data)
  try {
    const res = await Net.http('account-money/account-service-fee-list', { data })
    Log('getServiceChargeAccountDetailList res:', res)
    return res
  } catch (err) {
    Log('getServiceChargeAccountDetailList err:', err)
    throw err
  }
}

/** account-money/collect-account-service-fee-list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.operator_id
 * @param {*} data.type
 * @param {*} data.begin_time
 * @param {*} data.end_time
 * @param {*} data.version
*/
export async function serviceChargeAccountCollectList(data = {}) {
  Log('serviceChargeAccountCollectList data:', data)
  try {
    const res = await Net.http('account-money/collect-account-service-fee-list', { data })
    Log('serviceChargeAccountCollectList res:', res)
    return res
  } catch (err) {
    Log('serviceChargeAccountCollectList err:', err)
    throw err
  }
}

/** account/recharge-account
 * @param {Object} data
 * @param {*} data.account_id
 * @param {*} data.price
 * @param {*} data.pay_method
 * @param {*} data.version
*/
export async function createServiceChargeAccountOrder(data = {}) {
  Log('createServiceChargeAccountOrder data:', data)
  try {
    const res = await Net.http('account/recharge-account', { data })
    Log('createServiceChargeAccountOrder res:', res)
    return res
  } catch (err) {
    Log('createServiceChargeAccountOrder err:', err)
    throw err
  }
}

/** device-account/create-device-account-recharge-order
 * @param {Object} data
 * @param {*} data.operator_id
 * @param {*} data.uids
 * @param {*} data.org_ids
 * @param {*} data.flag
*/
export async function createServiceChargeAccountOrderByDevice(data = {}) {
  Log('createServiceChargeAccountOrderByDevice data:', data)
  try {
    const res = await Net.http('device-account/create-device-account-recharge-order', { data })
    Log('createServiceChargeAccountOrderByDevice res:', res)
    return res
  } catch (err) {
    Log('createServiceChargeAccountOrderByDevice err:', err)
    throw err
  }
}


/** === ServiceOrder === **/
/** service-fee-pay-order/list
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.from_operator_id
 * @param {*} data.to_operator_id
 * @param {*} data.begin_time
 * @param {*} data.end_time
*/
export async function getServiceOrderList(data = {}) {
  Log('getServiceOrderList data:', data)
  try {
    const res = await Net.http('service-fee-pay-order/list', { data })
    Log('getServiceOrderList res:', res)
    return res
  } catch (err) {
    Log('getServiceOrderList err:', err)
    throw err
  }
}

/** service-fee-pay-order/list-sub
 * @param {Object} data
 * @param {*} data.page
 * @param {*} data.from_operator_id
 * @param {*} data.to_operator_id
 * @param {*} data.begin_time
 * @param {*} data.end_time
*/
export async function getServiceOrderListSub(data = {}) {
  Log('getServiceOrderListSub data:', data)
  try {
    const res = await Net.http('service-fee-pay-order/list-sub', { data })
    Log('getServiceOrderListSub res:', res)
    return res
  } catch (err) {
    Log('getServiceOrderListSub err:', err)
    throw err
  }
}

/** service-fee-pay-order/detail
 * @param {Object} data
 * @param {*} data.id
*/
export async function getServiceOrderDetail(data = {}) {
  Log('getServiceOrderDetail data:', data)
  try {
    const res = await Net.http('service-fee-pay-order/detail', { data })
    Log('getServiceOrderDetail res:', res)
    return res
  } catch (err) {
    Log('getServiceOrderDetail err:', err)
    throw err
  }
}

/** pay/device-account-recharge-order-pay
 * @param {Object} data
 * @param {*} data.order_sn
 * @param {*} data.outer_user_id
*/
export async function serviceOrderOrderPay(data = {}) {
  Log('serviceOrderOrderPay data:', data)
  try {
    const res = await Net.http('pay/device-account-recharge-order-pay', { data })
    Log('serviceOrderOrderPay res:', res)
    return res
  } catch (err) {
    Log('serviceOrderOrderPay err:', err)
    throw err
  }
}

/** pay/device-account-recharge-order-cancel
 * @param {Object} data
 * @param {*} data.order_sn
*/
export async function serviceOrderOrderCancel(data = {}) {
  Log('serviceOrderOrderCancel data:', data)
  try {
    const res = await Net.http('pay/device-account-recharge-order-cancel', { data })
    Log('serviceOrderOrderCancel res:', res)
    return res
  } catch (err) {
    Log('serviceOrderOrderCancel err:', err)
    throw err
  }
}
